module.exports = __webpack_public_path__ + "img/share-text.6fa76e71.png";